var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import http, { Q } from "@http";
import { observable, action, runInAction, computed } from "mobx";
import { PredefinedServiceCategory, PredefinedWoType, PredefinePriority, } from "@common/enums/base";
import { includes } from "lodash-es";
import { cookie } from "@common/utils/storage";
import Cookies from "js-cookie";
var commonStore = /** @class */ (function () {
    function commonStore(questionStore) {
        this.future24hoursMaxApparentTempInfo = {};
        this.serviceCodeWOType = null;
        this.isDTC = false;
        this.clientId = Cookies.get("clientId");
        this.defaultPriority = {
            Priority: {},
            ServiceCode: {},
        };
        this.serviceParam = {};
        this.questionStore = questionStore;
    }
    commonStore.prototype.setParam = function (key, value) {
        var _a;
        Object.assign(this, (_a = {}, _a[key] = value, _a));
    };
    commonStore.prototype.init = function (serviceParam) {
        this.serviceParam = serviceParam;
        this.getDefaultPriority();
        this.getFuture24hoursMaxApparentTempInfo();
        if (this.isRecallCheck) {
            this.serviceCodeWOType = PredefinedWoType.Recall;
        }
        else {
            this.serviceCodeWOType = null;
            this.getServiceCodeWOType();
        }
    };
    commonStore.prototype.getHighestPriority = function (prioritys) {
        return [
            PredefinePriority.Critical,
            PredefinePriority.Emergency,
            PredefinePriority.NextAvailableService,
            PredefinePriority.RoutineExpeditedService,
            PredefinePriority.RoutineStandardService,
            PredefinePriority.Expedited,
            PredefinePriority.TuneUp,
            PredefinePriority.ResidentResponsibility,
        ].find(function (priority) { return includes(prioritys, priority); });
    };
    Object.defineProperty(commonStore.prototype, "priorityId", {
        get: function () {
            return this.defaultPriority && this.defaultPriority.PriorityId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(commonStore.prototype, "questionAnswers", {
        get: function () {
            return __spreadArrays(this.questionStore.keyQuestionsDataWithAnswers, this.questionStore.troubleShootingDataWithAnswers);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(commonStore.prototype, "priority", {
        get: function () {
            var priorities = this.questionAnswers.map(function (question) {
                var option = question.questionOptions.find(function (option) { return option.id === question.answerId; });
                return (option && option.priorityId) || null;
            });
            var isSelectHeatIndexOption = includes(priorities, PredefinePriority.FeelsLike);
            if (this.serviceCategoryId ===
                PredefinedServiceCategory.AirConditioningHeating &&
                this.future24hoursMaxApparentTempInfo.isActive &&
                isSelectHeatIndexOption) {
                priorities.push(this.future24hoursMaxApparentTempInfo.priorityId);
            }
            priorities = priorities.filter(function (i) { return i !== null; });
            var priority = priorities.length > 0 ? this.getHighestPriority(priorities) || this.priorityId : this.priorityId;
            console.log('priority: ', priority);
            return priority;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(commonStore.prototype, "woTypeId", {
        get: function () {
            var woTypes = this.questionAnswers
                .map(function (answer) {
                var questionOption = answer.questionOptions.find(function (item) { return item.id === answer.answerId; });
                return (questionOption && questionOption.woTypeId) || null;
            })
                .filter(function (x) { return !!x; });
            var woTypeId = this.serviceCodeWOType;
            if (woTypes && woTypes.length > 0) {
                woTypeId = Math.min.apply(null, woTypes);
            }
            console.log('woType: ', woTypeId);
            return woTypeId;
        },
        enumerable: false,
        configurable: true
    });
    commonStore.prototype.getDefaultPriority = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getDefaultPriority(this.serviceParam)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.defaultPriority = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    commonStore.prototype.getFuture24hoursMaxApparentTempInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var locationId, clientId, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        locationId = cookie("locationId");
                        clientId = cookie("clientId");
                        return [4 /*yield*/, this.api().getFuture24hoursMaxApparentTempInfo(clientId, locationId)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.future24hoursMaxApparentTempInfo = __assign(__assign({}, data), { isSelectHeatIndexOption: false });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    commonStore.prototype.getServiceCodeWOType = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getServiceCodeWOType(this.serviceParam)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.serviceCodeWOType = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    commonStore.prototype.getWoDetail = function (woId, isReactive) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getWoDetail(woId, isReactive)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.woDetail = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    commonStore.prototype.getIsEnableDTCConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getIsEnableDTCConfig()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.isDTC = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    commonStore.prototype.clear = function () {
        this.isRecallCheck = null;
        this.isDupCheck = null;
    };
    commonStore.prototype.api = function () {
        return {
            getFuture24hoursMaxApparentTempInfo: function (clientId, locationId) {
                return Q(http.post(buildURL() + "/GetFuture24hoursMaxApparentTempInfo?clientId=" + clientId + "&locationId=" + locationId + "&_=" + new Date().getTime()));
            },
            getDefaultPriority: function (param) {
                return Q(http.post(buildURL(param) + "/defaultPriority"));
            },
            getServiceCodeWOType: function (param) {
                return Q(http.post(buildURL(param) + "/serviceCodeWOType"));
            },
            getWoDetail: function (id, isReactive) {
                var url = isReactive ? 'Request' : 'Recurring';
                return Q(http.post("/RSP/" + url + "/" + id + "/WoDetail"));
            },
            getIsEnableDTCConfig: function () {
                return Q(http.get('/RSP/Request/IsEnableDTCConfig'));
            }
        };
    };
    __decorate([
        observable
    ], commonStore.prototype, "serviceCategoryId", void 0);
    __decorate([
        observable
    ], commonStore.prototype, "serviceTypeId", void 0);
    __decorate([
        observable
    ], commonStore.prototype, "serviceCodeId", void 0);
    __decorate([
        observable
    ], commonStore.prototype, "future24hoursMaxApparentTempInfo", void 0);
    __decorate([
        observable
    ], commonStore.prototype, "serviceCodeWOType", void 0);
    __decorate([
        observable
    ], commonStore.prototype, "questionStore", void 0);
    __decorate([
        observable
    ], commonStore.prototype, "woDetail", void 0);
    __decorate([
        observable
    ], commonStore.prototype, "isRecallCheck", void 0);
    __decorate([
        observable
    ], commonStore.prototype, "isDupCheck", void 0);
    __decorate([
        observable
    ], commonStore.prototype, "isDTC", void 0);
    __decorate([
        observable
    ], commonStore.prototype, "clientId", void 0);
    __decorate([
        observable
    ], commonStore.prototype, "defaultPriority", void 0);
    __decorate([
        observable
    ], commonStore.prototype, "serviceParam", void 0);
    __decorate([
        action.bound
    ], commonStore.prototype, "setParam", null);
    __decorate([
        action.bound
    ], commonStore.prototype, "init", null);
    __decorate([
        computed
    ], commonStore.prototype, "priorityId", null);
    __decorate([
        computed
    ], commonStore.prototype, "questionAnswers", null);
    __decorate([
        computed
    ], commonStore.prototype, "priority", null);
    __decorate([
        computed
    ], commonStore.prototype, "woTypeId", null);
    __decorate([
        action
    ], commonStore.prototype, "getDefaultPriority", null);
    __decorate([
        action
    ], commonStore.prototype, "getFuture24hoursMaxApparentTempInfo", null);
    __decorate([
        action
    ], commonStore.prototype, "getServiceCodeWOType", null);
    __decorate([
        action
    ], commonStore.prototype, "getWoDetail", null);
    __decorate([
        action
    ], commonStore.prototype, "getIsEnableDTCConfig", null);
    __decorate([
        action.bound
    ], commonStore.prototype, "clear", null);
    return commonStore;
}());
export default commonStore;
export var buildURL = function (serviceParam) {
    return serviceParam
        ? "RSP/NewRequest/" + serviceParam.serviceCategoryId + "/" + serviceParam.serviceTypeId + "/" + serviceParam.serviceCodeId
        : "RSP/NewRequest";
};
